import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="mainContent"> {/* Removed styles. prefix */}
    Sterling Rain Projects LTD is a full-service production house based in New York, specializing in long and short form documentary storytelling with work featured on streaming platforms, and in film festivals and museums worldwide. Our broadcast and feature documentary expertise informs our approach to event capture, live panels, B2B, branded, and social content—whether in-studio or on-location. 
<p />
With a trusted network of directors, producers, camera crews, still photographers, and fixers across the U.S. and Canada, we bring high-end production value to every project. And our post-production team delivers on any deadline, providing final color grading, sound mixing, and dynamic graphic assets to ensure an incisive, polished, and high-impact result.


    </div>
  );
};

export default AboutPage;